import { motion } from "framer-motion";

const leftLinks = [
    { label: "Philosophy", href: "#about" },
    { label: "Services", href: "#services" },
];
const rightLinks = [
    { label: "Fleet", href: "#fleet" },
    { label: "Enquire", href: "#enquire" },
];

const LOGO =
    "https://customer-assets.emergentagent.com/job_luxury-facilitation/artifacts/6k1jx2uv_MP%20LOGO%20NEW.png";

export default function Nav({ scrolled }) {
    return (
        <motion.header
            initial={{ y: -40, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.9, delay: 3.4, ease: [0.2, 0.7, 0.2, 1] }}
            data-testid="site-nav"
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
                scrolled
                    ? "bg-[#F9F8F6]/85 backdrop-blur-xl border-b border-bone"
                    : "bg-transparent"
            }`}
        >
            <div
                className={`max-w-[1500px] mx-auto px-6 md:px-12 flex items-center justify-between transition-all duration-500 ${
                    scrolled ? "h-20 md:h-24" : "h-24 md:h-32"
                }`}
            >
                {/* Left links */}
                <nav className="hidden md:flex items-center gap-10 flex-1">
                    {leftLinks.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`nav-link-${l.label.toLowerCase()}`}
                            className={`font-sans text-[11px] uppercase tracking-[0.32em] transition-colors duration-500 hover:text-[#C5A880] ${
                                scrolled ? "text-[#1A1A1A] hover:text-oxblood" : "text-[#F9F8F6]"
                            }`}
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>

                {/* Centre logo */}
                <a
                    href="#top"
                    data-testid="brand-mark"
                    aria-label="Monplaisir Group"
                    className="flex-shrink-0 group"
                >
                    <img
                        src={LOGO}
                        alt="Monplaisir Group"
                        className={`w-auto transition-all duration-500 ${
                            scrolled
                                ? "h-16 md:h-20 invert opacity-90"
                                : "h-20 md:h-28 opacity-100"
                        }`}
                    />
                </a>

                {/* Right links + CTA */}
                <nav className="hidden md:flex items-center justify-end gap-10 flex-1">
                    {rightLinks.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`nav-link-${l.label.toLowerCase()}`}
                            className={`font-sans text-[11px] uppercase tracking-[0.32em] transition-colors duration-500 hover:text-[#C5A880] ${
                                scrolled ? "text-[#1A1A1A] hover:text-oxblood" : "text-[#F9F8F6]"
                            }`}
                        >
                            {l.label}
                        </a>
                    ))}
                    <a
                        href="#enquire"
                        data-testid="nav-cta"
                        className={`font-sans text-[11px] uppercase tracking-[0.32em] pb-1 border-b transition-colors duration-500 ${
                            scrolled
                                ? "text-[#1A1A1A] border-[#1A1A1A] hover:text-oxblood hover:border-oxblood"
                                : "text-[#E5C7A1] border-[#C5A880] hover:text-[#F9F8F6] hover:border-[#F9F8F6]"
                        }`}
                    >
                        Request
                    </a>
                </nav>

                {/* Mobile — minimal CTA */}
                <a
                    href="#enquire"
                    data-testid="nav-cta-mobile"
                    className={`md:hidden font-sans text-[10px] uppercase tracking-[0.28em] transition-colors duration-500 ${
                        scrolled ? "text-[#1A1A1A]" : "text-[#E5C7A1]"
                    }`}
                >
                    Request
                </a>
            </div>
        </motion.header>
    );
}
